import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=7220bd92"
import script from "./resources.js?vue&type=script&lang=js&external"
export * from "./resources.js?vue&type=script&lang=js&external"
import style0 from "./resources.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports